export const PAYMENTS_TYPES = {
  LOAD_PAYMENTS: "LOAD_PAYMENTS",
  SET_PAYMENTS: "SET_PAYMENTS",
  CLEAR_PAYMENTS: "CLEAR_PAYMENTS",
  SET_ACCOUNTS: "SET_ACCOUNTS",
  SET_SELECTED_ACCOUNT: "SET_SELECTED_ACCOUNT",
  HANDLE_PAYMENTS_INPUTS: "HANDLE_PAYMENTS_INPUTS",
};
